import Vue from 'vue';

function deepSet(obj, value, path) {
	let i;
	path = path.split('.');
	for (i = 0; i < path.length - 1; i++) obj = obj[path[i]];

	obj[path[i]] = value;
}

Vue.directive('string', {
	bind: function (el, binding, vnode) {
		const handler = (e) => {
			const value = e.target.value;

			if (/\d/.test(value)) {
				el.dataset.invalid = 'field with numbers';

				if (vnode.componentInstance) {
					vnode.componentInstance.$emit('in-valid', { valid: false });
				}

				deepSet(vnode.context.$data, null, binding.expression);
			} else {
				delete el.dataset.invalid;
				if (vnode.componentInstance) {
					vnode.componentInstance.$emit('in-valid', { valid: true });
				}
				deepSet(vnode.context.$data, value.trim(), binding.expression);
			}
		};
		el.addEventListener('change', handler);
	},
});
